import styled from '@emotion/styled';

export const Spacer = styled.div<{ height?: string; width?: string }>`
  height: ${(props) => (props.height ? props.height : 'initial')};
  width: ${(props) => (props.width ? props.width : 'initial')};
`;
